import {useState} from "react";
import {isNullOrUndefined} from "../../../services/Validator";
import DetailedCourseScreen from "../../../screens/courses/DetailedCourseScreen";
import {useResizeListener} from "../../../listeners/SystemResizeListener";
import SystemIcon from "../../icons/SystemIcon";
import CoursesLevelATaskText from "../../texts/courses/CoursesLevelATaskText";
import SystemHorizontalStarDivider from "../../dividers/courses/flash/SystemHorizontalStarDivider";

export default function CoursesLevelAItem({ index,
                                            total,
                                            levelA,
                                            selectedLevelAs,
                                            pickLevelA,
                                            clearLevelAs,
                                            // ---- Flash
                                            isFlashLoading,
                                            fetchFlashQuestions,
                                            // ---- Exerciser
                                            isExerciserLoading,
                                            fetchExerciserProblem }) {
    // Used in LevelDesktopSchoolLevelsList to display one single
    // level card

    // PROPERTIES
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isHovered, setIsHovered] = useState(false)

    // HOOKS
    // ---- Eventually close modal during screen resize
    useResizeListener(() => setIsModalOpen(false))

    // BUILD
    if (isNullOrUndefined(levelA) || isNullOrUndefined(selectedLevelAs))
        return null
    return (
        <div className="w-full flex flex-col space-y-[6px]">
            {/** LEVEL A MODAL */}
            <DetailedCourseScreen open={isModalOpen}
                                  handleClose={processModalClosing}
                                  fetchFlashQuestions={fetchFlashQuestions}
                                  isFlashLoading={isFlashLoading}
                                  levelA={levelA}
                                  isExerciserLoading={isExerciserLoading}
                                  fetchExerciserProblem={fetchExerciserProblem} />
            {/** CORE */}
            <div className={`cursor-pointer w-full flex justify-between items-center px-[16px] py-[8px]`}
                 onClick={processModalOpening}
                 onMouseEnter={() => setIsHovered(true)}
                 onMouseLeave={() => setIsHovered(false)}>
                {/** CORE CONTENT */}
                <CoursesLevelATaskText taskText={levelA?.task}
                                       isHovered={isHovered}/>
                <SystemIcon icon={"chevron_right"}
                            isHovered={isHovered} />
            </div>
            {/** BOTTOM DIVIDER IF NECESSARY */}
            {index === (total - 1) ? null : <SystemHorizontalStarDivider />}
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isModalOpen) {
            pickLevelA(levelA);
            setIsModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isModalOpen) {
            clearLevelAs()
            setIsModalOpen(false)
        }
    }
}